export default {
  hero: {
    header: 'YOUR MONEY DESERVES MORE',
    subHeader: 'Commercial Real Estate Can Augment Your Investing Strategy',
  },
  passiveIncome: {
    heading: 'Adding Passive Income To Your Portfolio',
    body: [
      'Passive income is exactly what it sounds like: periodic disbursements without significant effort beyond your initial investment.',
      'While real estate has traditionally been considered a passive investment strategy, owning rental properties generally requires considerable effort, including overseeing the purchase, performing inspections, finding tenants and property management.',
      'While investors should always perform their own due diligence before investing, RealtyMogul conducts rigorous due diligence and provides asset management on all its properties offering a truly passive investing experience.',
    ],
  },
  distributions: {
    heading: 'Meet Passive Income Goals With Select Investments',
    body: [
      'The potential production of steady monthly rental income can make real estate an ideal cash-flow investment.',
    ],
    legend: 'In Investor Disbursements',
  },
  growthGoals: {
    heading: 'See How Real Estate Can Help Achieve Growth Goals',
    body: [
      'With fewer fluctuations than the stock market and higher historic long-term gains, real estate investing can be attractive to growth investors. In select RealtyMogul investments, dividends can be reinvested to leverage the potential of compound interest, enhancing earning potential.',
    ],
    legend: 'Annualized Returns (%) as of 6/30/19',
    disclosure: [
      'Bloomberg Barclays US Aggregate Bont TR USD data source from MorningStar',
      '(https://performance.morningstar.com/Performance/index-c/performance-return.action?t=XIUSA000MC).',
      'S&P 500 Index and NARIT Equity REIT Index data sourced from NCREIF (NCREIF.org)',
    ],
  },
  diversified: {
    heading: 'What does a diversified portfolio look like?',
    body: [
      'There are a variety of methods investors may use to determine their ideal portfolio allocation. But too often portfolios leave out an important asset class – commercial real estate. While the appropriate allocation of CRE will vary by investor based on their age, financial goals or income, we believe it should be considered as part of a diversified portfolio.',
    ],
    legend: 'Efficient Frontier: Traditional Investments With & Without Alternatives',
    disclosure: [
      'Based on the returns of the S&P 500 Index, Barclays U.S. Aggregate Bond Index, and the NCREIF (National Council of Real Estate Investment Fiduciaries) Index, and with and without an asset allocation to direct real estate, over an 11-year time period (2006-2016).',
      'Each index provides a broad representation of a particular asset class and is not indicative of any investment or a projection of performance.  Asset allocation does not ensure a profit or protect against a loss. The rates of returns shown do not reflect the deduction of fees and expenses inherent in investing.',
    ],
  },
  diversifiedPortfolio: {
    heading: 'Create a diversified portfolio',
    body: [
      'Many investors believe that they are protected against public market volatility since their portfolio includes a range of asset classes, such as stocks and bonds. However, to bring genuine diversity, investors may consider adding primary alternatives like real estate. RealtyMogul offers both “MogulREITs” and private placement deals - assets not traded on, or tied to the stock market. ',
    ],
  },
  growWealth: {
    heading: 'A Strategy to grow wealth',
    body: [
      'A traditional growth strategy leverages investments that may increase in value over the long haul. For buy-and-hold real estate investors, this means investing in properties with potential for appreciation, with the intention of profiting at the time of sale. Additionally, ideal properties may even offer quarterly dividends over the course of ownership.',
    ],
  },
  passiveIos: {
    heading: 'Passive Income Opportunities Available Today',
    investments: [
      {
        id: 2,
        title: 'Available to accredited investors only',
        titleToolTip: true,
        path: '/investment-opportunities',
        status: 'status-10-open',
        statusLabel: 'Open for investment',
        assetCount: 1,
        REIT: false,
        imageName: 'img_card_locked',
        propertyLocation: 'Private Placements',
        investmentType: 'REIT',
        investmentTypeDisplay: 'Equity',
        targetHoldPeriod: null,
        minimum: 'Varied',
        propertyType: 'Varied',
        targetHoldMin: null,
        targetHoldMax: 'Varied',
        payout: 1,
        includeProgress: true,
        blurb: 'Individual properties fully vetted with the investment objective of capital appreciation and income.  Apply for access to Private Placements during registration.',
        blurContent: true,
      },
    ],
  },
  growthIos: {
    heading: 'Growth Opportunities Available Today',
    investments: [
      {
        id: 4,
        title: 'Available to accredited investors only',
        titleToolTip: true,
        path: '/investment-opportunities',
        status: 'status-10-open',
        statusLabel: 'Open for investment',
        assetCount: 1,
        REIT: false,
        imageName: 'img_card_locked',
        propertyLocation: 'Private Placements',
        investmentType: 'REIT',
        investmentTypeDisplay: 'Equity',
        targetHoldPeriod: null,
        minimum: 'Varied',
        propertyType: 'Varied',
        targetHoldMin: null,
        targetHoldMax: 'Varied',
        payout: 1,
        includeProgress: true,
        blurb: 'Individual properties fully vetted with the investment objective of capital appreciation and income.  Apply for access to Private Placements during registration.',
        blurContent: true,
      },
    ],
  },
  diversifyIos: {
    heading: 'Diversification Opportunities Available Today',
    investments: [
      {
        id: 7,
        title: 'Available to accredited investors only',
        titleToolTip: true,
        path: '/investment-opportunities',
        status: 'status-10-open',
        statusLabel: 'Open for investment',
        assetCount: 1,
        REIT: false,
        imageName: 'img_card_locked',
        propertyLocation: 'Private Placements',
        investmentType: 'REIT',
        investmentTypeDisplay: 'Equity',
        targetHoldPeriod: null,
        minimum: 'Varied',
        propertyType: 'Varied',
        targetHoldMin: null,
        targetHoldMax: 'Varied',
        payout: 1,
        includeProgress: true,
        blurb: 'Individual properties fully vetted with the investment objective of capital appreciation and income.  Apply for access to Private Placements during registration.',
        blurContent: true,
      },
    ],
  },
};
